/* This file was created automatically, don't change it manually. */

import React, { forwardRef } from 'react';

import { IconBaseProps } from '../../types';
import { SVGContainer } from '../../SVGContainer';

const IconYandexLogo20 = forwardRef<SVGSVGElement, IconBaseProps>(function IconYandexLogo20(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 20 20" ref={ref}>
            <g clipPath="url(#dc-YandexLogo20-a)">
                <mask
                    id="dc-YandexLogo20-b"
                    style={{ maskType: 'alpha' }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="20"
                    height="20"
                >
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M.852 2.852C0 4.262 0 6.175 0 10c0 3.825 0 5.738.852 7.148a5.909 5.909 0 0 0 2 2C4.262 20 6.175 20 10 20c3.825 0 5.738 0 7.148-.852a5.909 5.909 0 0 0 2-2C20 15.738 20 13.825 20 10c0-3.825 0-5.738-.852-7.148a5.909 5.909 0 0 0-2-2C15.738 0 13.825 0 10 0 6.175 0 4.262 0 2.852.852a5.91 5.91 0 0 0-2 2Z"
                        fill="#fff"
                    />
                </mask>
                <g mask="url(#dc-YandexLogo20-b)">
                    <path fill="#FC3F1D" d="M0 0h20v20H0z" />
                    <path
                        d="M11.411 16.01h2.09v-12h-3.04C7.406 4.01 5.8 5.58 5.8 7.895c0 1.847.88 2.935 2.451 4.057L5.523 16.01h2.262l3.04-4.541-1.054-.708c-1.278-.863-1.9-1.537-1.9-2.987 0-1.278.898-2.141 2.608-2.141h.932V16.01Z"
                        fill="#fff"
                    />
                </g>
            </g>
            <defs>
                <clipPath id="dc-YandexLogo20-a">
                    <rect width="20" height="20" rx="10" fill="#fff" />
                </clipPath>
            </defs>
        </SVGContainer>
    );
});

const IconYandexLogo24 = forwardRef<SVGSVGElement, IconBaseProps>(function IconYandexLogo24(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 24 24" ref={ref}>
            <g clipPath="url(#dc-YandexLogo24-a)">
                <mask
                    id="dc-YandexLogo24-b"
                    style={{ maskType: 'alpha' }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="24"
                    height="24"
                >
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M1.023 3.423C0 5.114 0 7.409 0 12c0 4.59 0 6.886 1.023 8.578a7.09 7.09 0 0 0 2.4 2.4C5.114 24 7.409 24 12 24c4.59 0 6.886 0 8.578-1.023a7.09 7.09 0 0 0 2.4-2.4C24 18.887 24 16.59 24 12s0-6.886-1.023-8.577a7.09 7.09 0 0 0-2.4-2.4C18.887 0 16.59 0 12 0S5.114 0 3.423 1.023a7.091 7.091 0 0 0-2.4 2.4Z"
                        fill="#fff"
                    />
                </mask>
                <g mask="url(#dc-YandexLogo24-b)">
                    <path fill="#FC3F1D" d="M0 0h24v24H0z" />
                    <path
                        d="M13.69 19.212h2.507v-14.4h-3.646c-3.668 0-5.594 1.885-5.594 4.662 0 2.217 1.056 3.522 2.942 4.869l-3.274 4.869h2.714l3.647-5.45-1.264-.849c-1.533-1.036-2.28-1.844-2.28-3.584 0-1.533 1.078-2.57 3.13-2.57h1.118v12.453Z"
                        fill="#fff"
                    />
                </g>
            </g>
            <defs>
                <clipPath id="dc-YandexLogo24-a">
                    <rect width="24" height="24" rx="12" fill="#fff" />
                </clipPath>
            </defs>
        </SVGContainer>
    );
});

const IconYandexLogo32 = forwardRef<SVGSVGElement, IconBaseProps>(function IconYandexLogo32(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 32 32" ref={ref}>
            <g clipPath="url(#dc-YandexLogo32-a)">
                <mask
                    id="dc-YandexLogo32-b"
                    style={{ maskType: 'alpha' }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="32"
                    height="32"
                >
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M1.364 4.563C0 6.82 0 9.88 0 16c0 6.12 0 9.181 1.364 11.437a9.453 9.453 0 0 0 3.2 3.2C6.818 32 9.878 32 16 32c6.12 0 9.181 0 11.437-1.364a9.452 9.452 0 0 0 3.2-3.2C32 25.182 32 22.122 32 16c0-6.12 0-9.181-1.364-11.437a9.453 9.453 0 0 0-3.2-3.2C25.182 0 22.122 0 16 0 9.88 0 6.819 0 4.563 1.364a9.455 9.455 0 0 0-3.2 3.2Z"
                        fill="#fff"
                    />
                </mask>
                <g mask="url(#dc-YandexLogo32-b)">
                    <path fill="#FC3F1D" d="M0 0h32v32H0z" />
                    <path
                        d="M18.253 25.616h3.342v-19.2h-4.862c-4.89 0-7.459 2.514-7.459 6.216 0 2.956 1.409 4.696 3.923 6.492l-4.365 6.492h3.619l4.862-7.266-1.685-1.132c-2.044-1.382-3.039-2.459-3.039-4.78 0-2.044 1.437-3.425 4.172-3.425h1.492v16.603Z"
                        fill="#fff"
                    />
                </g>
            </g>
            <defs>
                <clipPath id="dc-YandexLogo32-a">
                    <rect width="32" height="32" rx="16" fill="#fff" />
                </clipPath>
            </defs>
        </SVGContainer>
    );
});

const IconYandexLogo48 = forwardRef<SVGSVGElement, IconBaseProps>(function IconYandexLogo48(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 48 48" ref={ref}>
            <g clipPath="url(#dc-YandexLogo48-a)">
                <mask
                    id="dc-YandexLogo48-b"
                    style={{ maskType: 'alpha' }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="48"
                    height="48"
                >
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M2.045 6.845C0 10.228 0 14.819 0 24c0 9.181 0 13.772 2.045 17.155a14.18 14.18 0 0 0 4.8 4.8C10.228 48 14.819 48 24 48c9.181 0 13.772 0 17.155-2.045a14.18 14.18 0 0 0 4.8-4.8C48 37.772 48 33.18 48 24c0-9.181 0-13.772-2.045-17.155a14.18 14.18 0 0 0-4.8-4.8C37.772 0 33.18 0 24 0 14.819 0 10.228 0 6.845 2.045a14.182 14.182 0 0 0-4.8 4.8Z"
                        fill="#fff"
                    />
                </mask>
                <g mask="url(#dc-YandexLogo48-b)">
                    <path fill="#FC3F1D" d="M0 0h48v48H0z" />
                    <path
                        d="M27.38 38.424h5.015v-28.8H25.1c-7.334 0-11.188 3.771-11.188 9.324 0 4.434 2.113 7.044 5.884 9.738l-6.547 9.738h5.428l7.294-10.898-2.528-1.7c-3.066-2.071-4.558-3.687-4.558-7.168 0-3.067 2.155-5.139 6.257-5.139h2.238v24.905Z"
                        fill="#fff"
                    />
                </g>
            </g>
            <defs>
                <clipPath id="dc-YandexLogo48-a">
                    <rect width="48" height="48" rx="24" fill="#fff" />
                </clipPath>
            </defs>
        </SVGContainer>
    );
});

export const IconYandexLogo = forwardRef<SVGSVGElement, IconBaseProps>(function IconYandexLogo(props, ref) {
    const { size = '16' } = props;

    const iconProps = {
        ...props,
        size,
        ref,
    } as const;

    switch (size) {
        case '20':
            return <IconYandexLogo20 {...iconProps} />;
        case '24':
            return <IconYandexLogo24 {...iconProps} />;
        case '32':
            return <IconYandexLogo32 {...iconProps} />;
        case '48':
            return <IconYandexLogo48 {...iconProps} />;
        default:
            return <IconYandexLogo48 {...iconProps} />;
    }
});
